<admin-app-header *ngIf="!isSalesManagerMode"></admin-app-header>

<div class="crm-page">
    <div class="container-fluid">
        <div class="page-header desktop-only">
            <h1>Expiring Leases</h1>
            <div class="page-header__actions">
                <div class="view-toggle">
                    <button class="toggle-btn" [class.active]="view === 'table'" (click)="view = 'table'">
                        <i class="fa-solid fa-table"></i> Table
                    </button>
                    <button class="toggle-btn" [class.active]="view === 'stats'" (click)="view = 'stats'">
                        <i class="fa-solid fa-chart-pie"></i> Stats
                    </button>
                </div>
                <div class="filter-field" *ngIf="view === 'table'">
                    <select class="filter-select" [(ngModel)]="expiryWindowDays" (ngModelChange)="onExpiryWindowChange()">
                        <option *ngFor="let opt of expiryWindowOptions" [ngValue]="opt.value">Expiring within {{ opt.label }}</option>
                    </select>
                </div>
                <div class="filter-field" *ngIf="view === 'stats'">
                    <select class="filter-select" [(ngModel)]="statsLookbackDays" (ngModelChange)="onStatsLookbackChange()">
                        <option *ngFor="let opt of statsLookbackOptions" [ngValue]="opt.value">Expired in last {{ opt.label }}</option>
                    </select>
                </div>
            </div>
        </div>

        <ng-container *ngIf="!searchReady">
            <div class="loading-state">
                <i class="fa-solid fa-spinner fa-spin"></i>
                <p>Loading expiring leases...</p>
            </div>
        </ng-container>

        <ng-container *ngIf="searchReady && view === 'table'">
            <app-expiring-leases-table
                [expiringRows]="expiringRows"
                [expiredRows]="expiredRows"
                [crmAssignees]="crmAssignees"
                [crmAssigneeMap]="crmAssigneeMap"
            ></app-expiring-leases-table>
        </ng-container>

        <ng-container *ngIf="searchReady && view === 'stats'">
            <app-expiring-leases-stats
                [expiringRows]="expiringRows"
                [expiredRows]="statsExpiredRows"
                [crmAssigneeMap]="crmAssigneeMap"
            ></app-expiring-leases-stats>
        </ng-container>
    </div>
</div>
